import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    tooltip: {
        borderRadius: '12px',
        padding: `${spacing.xs} ${spacing.small}`,
        '& .MuiTooltip-arrow': {
            fontSize: '2rem',
        },
    },
    popper: {
        zIndex: 1,
    },
    link: Object.assign(Object.assign({}, theme.typography.medium_bold), { color: colors.background.WHITE }),
    hotspotContainer: Object.assign(Object.assign({}, theme.typography.large_regular), { position: 'absolute', height: '100%', width: '100%', right: 0, left: 0, top: 0 }),
    hotspot: {
        position: 'absolute',
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        minWidth: 0,
        display: 'flex',
    },
}));
export default useStyles;
